export type PushEntryDomain = "invest" | "plan";

export type PushEntryMarker = {
  domain: PushEntryDomain;
  createdAt: number;
};

const STORAGE_KEY = "edgen_push_entry_marker_v1";

function canUseSessionStorage(): boolean {
  return typeof window !== "undefined" && typeof sessionStorage !== "undefined";
}

export function setPushEntryMarker(domain: PushEntryDomain): void {
  if (!canUseSessionStorage()) {
    return;
  }
  const marker: PushEntryMarker = { domain, createdAt: Date.now() };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(marker));
}

export function getPushEntryMarker(): PushEntryMarker | null {
  if (!canUseSessionStorage()) {
    return null;
  }
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as PushEntryMarker;
    if (parsed?.domain !== "invest" && parsed?.domain !== "plan") {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearPushEntryMarker(): void {
  if (!canUseSessionStorage()) {
    return;
  }
  sessionStorage.removeItem(STORAGE_KEY);
}

/** 从 Push payload / 路由推断返回域 */
export function inferPushEntryDomain(input: {
  domain?: string;
  routePath?: string;
  pushType?: string;
}): PushEntryDomain {
  if (input.domain === "plan" || input.domain === "invest") {
    return input.domain;
  }
  if (input.pushType?.startsWith("fcm.title.recall.goal.")) {
    return "plan";
  }
  if (input.routePath?.startsWith("/plan")) {
    return "plan";
  }
  if (input.routePath?.startsWith("/desk")) {
    return "invest";
  }
  return "invest";
}
